const img = (id, w = 2000) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const BRAND = {
  name: "INVOGUE",
  tag: "PRIVATE & CORPORATE CONCIERGE",
  tagline: "UNE DEMANDE. UNE SOLUTION.",
  phone: "+33 1 89 62 98 78",
  phoneTel: "+33189629878",
  email: "contact@invogueconcierge.com",
};

export const IMAGES = {
  hero: "/hero-estate.jpg",
  residenceFeature: img("photo-1613490493576-7fde63acd811"),
  interior: img("photo-1600607687939-ce8a6c25118c"),
  hotel: img("photo-1582719508461-905c673771fd"),
  hotelDusk: img("photo-1551882547-ff40c63fe5fa"),
  chauffeur: img("photo-1449965408869-eaa3f722e40d"),
  executive: img("photo-1507679799987-c73779587ccf"),
  nightCity: img("photo-1519501025264-65ba15a82390"),
  desk: img("photo-1454165804606-c3d57bc86b40"),
  travel: img("photo-1436491865332-7a61a109cc05"),
  aviationWing: img("photo-1540962351504-03099e0a754b"),
  aviationEngine: img("photo-1474302770737-173ee21bab63"),
};

export const NAV_LINKS = [
  { label: "Services", hash: "#services" },
  { label: "Privé", hash: "#prive" },
  { label: "Corporate", hash: "#corporate" },
  { label: "Travel", hash: "#travel" },
  { label: "À propos", hash: "#approche" },
];

export const TRUST_ITEMS = [
  "UN SEUL INTERLOCUTEUR",
  "RÉSEAU DE PRESTATAIRES SÉLECTIONNÉS",
  "RECHERCHE & SOURCING",
  "NÉGOCIATION",
  "COORDINATION DE BOUT EN BOUT",
];

export const SERVICES = [
  {
    id: "residence",
    num: "01",
    title: "RESIDENCE & PROPERTY",
    items: ["Ménage & housekeeping", "Jardinage & élagage", "Maintenance", "Interventions techniques", "Artisans de confiance", "Recherche immobilière", "Remise en état", "Urgences"],
    cta: "Confier une demande",
    note: "Nous ne réalisons pas les prestations : nous trouvons les bons professionnels et nous coordonnons tout.",
    image: img("photo-1600607687939-ce8a6c25118c"),
    span: "md:col-span-7",
    height: "h-[420px] md:h-[560px]",
  },
  {
    id: "corporate",
    num: "02",
    title: "CORPORATE",
    items: ["Fournisseurs & prestataires", "Voyages d'affaires", "Hôtels", "Événements", "Traiteurs", "Logistique", "Véhicules & flotte", "Cadeaux d'affaires"],
    cta: "Déléguer une demande",
    image: img("photo-1507679799987-c73779587ccf"),
    span: "md:col-span-5",
    height: "h-[420px] md:h-[560px]",
  },
  {
    id: "private",
    num: "03",
    title: "PRIVATE CONCIERGE",
    items: ["Demandes personnelles", "Réservations", "Événements privés", "Expériences", "Recherche & sourcing", "Automobile", "Achats", "Dernière minute"],
    cta: "Adresser une demande",
    image: img("photo-1582719508461-905c673771fd"),
    span: "md:col-span-12",
    height: "h-[320px] md:h-[400px]",
  },
  {
    id: "travel",
    num: "04",
    title: "TRAVEL",
    items: ["Business & First", "Hôtels & villas", "Transferts", "Itinéraires", "Aviation privée", "Empty legs", "Charter"],
    cta: "Explorer le travel desk",
    image: img("photo-1436491865332-7a61a109cc05"),
    span: "md:col-span-7",
    height: "h-[380px] md:h-[440px]",
    target: "#travel",
  },
  {
    id: "mobility",
    num: "05",
    title: "MOBILITY",
    items: ["Chauffeurs", "Transferts", "Véhicules avec chauffeur", "Logistique de déplacement"],
    cta: "Demander un chauffeur",
    image: img("photo-1449965408869-eaa3f722e40d"),
    span: "md:col-span-5",
    height: "h-[380px] md:h-[440px]",
  },
  {
    id: "exceptional",
    num: "06",
    title: "EXCEPTIONAL REQUESTS",
    items: ["Une demande spécifique ?", "Nous recherchons la solution."],
    cta: "Soumettre une demande",
    image: img("photo-1519501025264-65ba15a82390"),
    span: "md:col-span-12",
    height: "h-[300px] md:h-[360px]",
  },
];

export const REQUEST_EXAMPLES = [
  "« J'ai besoin d'un jardinier cette semaine. »",
  "« Trouvez-moi un prestataire fiable pour préparer cette maison. »",
  "« Il nous faut un chauffeur demain matin. »",
  "« Je cherche un appartement pour six mois, Paris 16e. »",
  "« Trouvez un traiteur pour 25 personnes. »",
  "« Il nous faut un hébergement pour 12 collaborateurs à Paris. »",
  "« Je cherche un électricien de confiance. »",
  "« Trouvez-moi ce modèle de voiture précis. »",
  "« Trouvez-moi un vol pour Genève. »",
  "« Avez-vous un empty leg Paris — Nice ? »",
  "« Quelqu'un peut-il simplement s'en occuper ? »",
];

export const NETWORK_CATEGORIES = [
  "ARTISANS", "MAINTENANCE", "HÔTELLERIE", "CHAUFFEURS", "AUTOMOBILE", "JARDINAGE",
  "ÉVÉNEMENTIEL", "TRAITEURS", "AVIATION", "SÉCURITÉ", "VOYAGES", "IMMOBILIER", "LOGISTIQUE",
];

export const WHY_PRINCIPLES = [
  { num: "01", title: "TIME", text: "Nous éliminons les recherches, les appels et les relances inutiles." },
  { num: "02", title: "NETWORK", text: "Nous identifions les bonnes personnes pour chaque demande." },
  { num: "03", title: "SOURCING", text: "Nous recherchons et comparons les solutions pertinentes." },
  { num: "04", title: "NEGOTIATION", text: "Lorsque c'est utile, nous recherchons de meilleures conditions." },
  { num: "05", title: "COORDINATION", text: "Nous restons votre interlocuteur unique jusqu'à la résolution de votre demande." },
];
